import { fetchLogoSrc } from '../../assets/js/common';

const convertToSquareFavicon = (imageUrl, size = 64) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, size, size);

      const scale = Math.min(size / img.width, size / img.height);
      const x = (size - img.width * scale) / 2;
      const y = (size - img.height * scale) / 2;

      ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
      resolve(canvas.toDataURL('image/png'));
    };
    img.src = imageUrl;
  });
};

export const setDynamicFavicon = async (customerId) => {
  const logoSrc = await fetchLogoSrc(customerId);
  if (!logoSrc) return;

  const squaredIcon = await convertToSquareFavicon(logoSrc);

  const link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/png";
  link.rel = "icon";
  link.href = squaredIcon;
  document.head.appendChild(link);
};

